<script lang="ts" setup>
import { FloatingBadgeProps } from './_types';

const props = withDefaults(defineProps<FloatingBadgeProps>(), {
    offset: () => [-3, -4],
    textColor: 'primary',
    color: 'on-primary',
});
</script>
<template>
    <q-badge v-bind="props" floating :style="{ top: `${offset[1]}px`, right: `${offset[0]}px` }">
        <template #default>
            <slot name="default" />
        </template>
    </q-badge>
</template>
